import { render } from "./ManagementTab.vue?vue&type=template&id=175b21d7&ts=true"
import script from "./ManagementTab.vue?vue&type=script&lang=ts"
export * from "./ManagementTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__